module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi/access/chiba_funabashi_point1_4-00d0db8e69d5dc63938b3205cf0f6167.jpg";